import {
  BrewGuideCardPropsExtended,
  DropdownOption,
} from "@bluebottlecoffee/design-system/components";
import { brewGuidePage } from "../link-builders";
import { BrewGuide } from "../sanity-schema";
import { toImageProps } from "./image";

export function toBrewGuideCardProps(
  data: BrewGuide,
  lang: string,
  region: string,
): BrewGuideCardPropsExtended {
  const circleDetailPlaceholderImage =
    "/ar_1:1,b_rgb:ffffff,bo_0px_solid_rgb:ffffff,c_crop,fl_clip,g_center,h_1000,r_1000,w_1000/v1630525715/roasted-beans_wfou4v.png";

  const image = data.card[0].image
    ? toImageProps(data.card[0].image, lang)
    : {
        src: circleDetailPlaceholderImage,
      };

  return {
    title: data.card[0].title[lang],
    subTitle: data.card[0].subTitle[lang],
    image,
    description: data.card[0].description?.[lang],
    timeText: data.card[0].timeText[lang],
    button: {
      text: data.card[0].buttonText[lang],
      link: brewGuidePage({ region, lang, slug: data.slug.current }),
    },
    type: data.card[0]?.type,
    sortByOptions:
      (data.card[0]?.sortBy as unknown as DropdownOption[])?.map((option) => ({
        display: option.display,
        value: option.value,
      })) ?? [],
  };
}
